/**
 * 完了画面のボタンイベント名 → login_popup 計測の trigger_button。
 * GA4 の trigger_button にそのまま入るので、既存の集計と値を揃える。
 */
export function toLoginPopupTriggerButton(eventName: string): string {
  switch (eventName) {
    case 'send-email-verification':
    case 'mail-PDF':
      return 'mail'
    case 'show-preview-4conv':
      return 'conv'
    case 'send-special-quickemail':
      return 'yagi'
    case 'download-PDF':
      return 'download'
    default:
      return eventName
  }
}
